// Libraries
import React, { createRef, useEffect } from 'react';
import { motion } from 'framer-motion'

// Hooks
import { useState } from 'react'
import { useToast } from '@chakra-ui/react'

// Providers
import { AnimatePresence } from 'framer-motion'

// Layouts
import { Footer } from "./layouts/Footer"
import { Header } from './layouts/Header'
import { FinalPage } from './layouts/FinalPage'

// Styles
import './App.css';
import {
  ContentWrap,
  Main,
  Ship,
  FullHeightFlex
} from './style'

// Pages
import {InitialPage} from './pages/Initial/index.'
import {StageOne} from './pages/StageOne'
import {StageTwo} from './pages/StageTwo'
import {StageThree} from './pages/StageThree'
import {StageFour} from './pages/StageFour'
import {StageFive} from './pages/StageFive'

const App = () => {
  const [currentStage, setCurrentStage] = useState(0)
  const [currentStageContent, setCurrentStageContent] = useState()
  const [data, setData] = useState({})

  const appendData = body => setData(prevState => ({...prevState, ...body}));

  const toast = useToast()

  const setStageAndToTop = (state) => {
    setCurrentStage(state)
    toTop()
  }

  useEffect(() => {
    const getCurrentStageElement = () => {
      switch (currentStage) {
        case 0:
          return <InitialPage setStageAndToTop={setStageAndToTop} currentStage={currentStage} />;
        case 1:
          return <StageOne setStageAndToTop={setStageAndToTop} appendData={appendData} currentStage={currentStage} />;
        case 2:
          return <StageTwo setStageAndToTop={setStageAndToTop} appendData={appendData} currentStage={currentStage} />;
        case 3:
          return <StageThree setStageAndToTop={setStageAndToTop} appendData={appendData} currentStage={currentStage} />;
        case 4:
          return <StageFour setStageAndToTop={setStageAndToTop} appendData={appendData} currentStage={currentStage} data={data} toast={toast} />;
        case 5:
          return <StageFive setStageAndToTop={setStageAndToTop} appendData={appendData} currentStage={currentStage} firstname={data.firstname} />;
        default:
          break;
      }
    }
    setCurrentStageContent(() => getCurrentStageElement())
  }, [currentStage])

  const headerRef = createRef()

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }


  return (
    <AnimatePresence>
      <motion.div className="App" initial={{ filter: 'grayscale(.5)', opacity: .5 }}
                                  animate={{ filter: 'grayscale(0)', opacity: 1 }}
                                  exit={{ filter: 'grayscale(.5)', opacity: 0 }}
                                  transition={{ duration: 2 }}>
        <Header ref={headerRef} />
        <Main>
          <ContentWrap>
            <FullHeightFlex>
              {currentStageContent}
            </FullHeightFlex>
            <Ship src='/ship.svg' initial={{ x: 0, opacity: .8 }}
                                  animate={{ x: -300, opacity: 1 }}
                                  exit={{ x: 300, opacity: 0 }}
                                  transition={{ duration: 6, repeat: Infinity, repeatType: 'mirror' }}
            />
          </ContentWrap>
        </Main>
        {currentStage === 5 && <FinalPage />}
        <Footer />
      </motion.div>
    </AnimatePresence>
  )
}

export default App;
